import { MagistralDrugTemplateFormBean } from './form/MagistralDrugTemplateForm.types';
import { MagistralDrugTemplateListItem } from './MagistralDrugTemplates.types';

export const mapMagistralDrugTemplateListItemToTemplateFormBean = (
   template: MagistralDrugTemplateListItem
): MagistralDrugTemplateFormBean => ({
   drugName: template.name ?? null,
   drugForm: template.form ?? null,
   medicineRawMaterials:
      template.magistralDrugMedicineRawMaterials?.map((material) => ({
         name: material.name ?? '',
         rpw: material.rpw,
         excessive: material.highDoseAlert,
         quantityAbbreviation: material.quantityAbbreviation ?? null,
         quantity: material.quantity ?? null,
         unit: material.quantityUnit ?? 'NONE',
      })) ?? [],
   additionalDetails: template.additionalDetails ?? null,
});
